import { useEffect } from 'react';
import concat from 'lodash/concat';
import { PLATFORM } from '../../../constants';
export function useSplitToGTM(factory) {
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (factory) {
            var client = factory.client();
            if (typeof window !== 'undefined' && window.dataLayer !== undefined) {
                window.dataLayer.push({ split_client: client });
                window.dataLayer.push({
                    event: 'split.content.view',
                    pathname: (_f = (_e = concat((_b = (_a = window.location) === null || _a === void 0 ? void 0 : _a.pathname) !== null && _b !== void 0 ? _b : '', (_d = (_c = window.location) === null || _c === void 0 ? void 0 : _c.search) !== null && _d !== void 0 ? _d : '')).join) === null || _f === void 0 ? void 0 : _f.call(_e, ''),
                    platform: ((_h = (_g = window.location) === null || _g === void 0 ? void 0 : _g.pathname) === null || _h === void 0 ? void 0 : _h.includes(PLATFORM.mweb))
                        ? PLATFORM.mweb
                        : PLATFORM.desktop
                });
            }
        }
    }, [factory]);
}
//# sourceMappingURL=useSplitToGTM.js.map